import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class PageHeaderTabs extends Component {
  static propTypes = {
    headerTabs: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.func
    ])
  };

  render() {
    const { headerTabs } = this.props;
    return (
      <div className="header-tabs">
        {headerTabs}
      </div>
    )
  }
}
